module.exports = ".four-zero-four {\n  position: fixed;\n  top: 50%;\n  z-index: 1000;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/errors-pages/not-found/not-found.component.scss
// module id = ./src/app/errors-pages/not-found/not-found.component.scss
// module chunks = main